module.exports = __webpack_public_path__ + "static/media/189cf7b3-ca08-4680-9e21-21952df51c7a.c7cd254d.png";